const preferences = {
  appLanguage: {
    helpText: 'Updates app language when localization is available.',
    label: 'App language',
    options: {
      en: 'English',
      enUS: 'English (United States)',
      enGB: 'English (United Kingdom)',
      enCA: 'English (Canada)',
      es: 'Spanish',
      esMX: 'Spanish (Mexico)',
      fr: 'French',
      frCA: 'French (Canada)',
    },
    useDeviceLanguage: 'Use device language',
  },
  assistantReplies: {
    helpText: 'Applies to new assistant replies only.',
    label: 'Assistant replies',
    matchAppLanguage: 'Match app language',
  },
  errors: {
    loadFailed: 'Unable to load preferences.',
    saveFailed: 'Unable to save this setting.',
  },
  savedPrompts: {
    actions: {
      delete: 'Delete prompt',
      edit: 'Edit prompt',
      moveDown: 'Move prompt down',
      moveUp: 'Move prompt up',
      new: 'New prompt',
      send: 'Send prompt',
    },
    ariaLabel: 'Saved prompts',
    deleteDialog: {
      confirmation: 'Delete <strong>{{title}}</strong>? This cannot be undone.',
      deleting: 'Deleting...',
      title: 'Delete saved prompt?',
    },
    editor: {
      cancel: 'Cancel',
      discardChanges: 'Discard changes',
      discardChangesMessage: 'Your unsaved prompt changes will be lost.',
      discardChangesTitle: 'Discard changes?',
      editTitle: 'Edit saved prompt',
      keepEditing: 'Keep editing',
      newTitle: 'New saved prompt',
      save: 'Save prompt',
      saving: 'Saving...',
    },
    empty: 'No saved prompts yet',
    errors: {
      createFailed: 'Unable to create this prompt.',
      deleteFailed: 'Unable to delete this prompt.',
      loadFailed: 'Unable to load saved prompts.',
      reorderFailed: 'Unable to reorder this prompt.',
      saveFailed: 'Unable to save this prompt.',
      updateFailed: 'Unable to update this prompt.',
    },
    form: {
      characterCount_one: '{{count}} / {{maximum}} character',
      characterCount_other: '{{count}} / {{maximum}} characters',
      promptTextLabel: 'Prompt',
      titleLabel: 'Title',
    },
    fromResponse: {
      action: 'Save as prompt',
      error: 'Unable to prepare a saved prompt. Please try again.',
      preparing: 'Preparing prompt...',
    },
    loading: 'Loading saved prompts',
    validation: {
      promptTextMax: 'Prompt text must be {{maximum}} characters or less.',
      promptTextRequired: 'Prompt text is required.',
      titleMax: 'Title must be {{maximum}} characters or less.',
      titleRequired: 'A title is required.',
    },
  },
  settings: {
    ariaLabel: 'User settings',
    loading: 'Loading settings',
    saving: 'Saving settings',
  },
} as const;

export default preferences;